import { render, staticRenderFns } from "./APIObjectDBEditorBase.vue?vue&type=template&id=1ce13c8a&scoped=true"
import script from "./APIObjectDBEditorBase.vue?vue&type=script&lang=js"
export * from "./APIObjectDBEditorBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce13c8a",
  null
  
)

export default component.exports